import React, { memo } from 'react';
import { cn } from '@/lib/utils';

// ============================================================================
// COMPACT INLINE STATS BAR
// ============================================================================

export const InboxStatsBar = memo(({
  stats = [],
  className = ''
}) => {
  return (
    <div className={cn(
      'flex items-center justify-center sm:justify-start flex-wrap gap-x-1 gap-y-0.5 sm:gap-0.5 py-0.5',
      className
    )}>
      {stats.map((stat, index) => (
        <React.Fragment key={stat.id || index}>
          <button
            onClick={stat.onClick}
            disabled={!stat.onClick}
            className={cn(
              'flex items-center gap-1 px-2 py-0.5 rounded-md text-xs transition-all flex-shrink-0',
              stat.onClick && 'hover:bg-slate-100 dark:hover:bg-zinc-800 cursor-pointer',
              stat.isActive && 'bg-indigo-50 dark:bg-indigo-950/30 ring-1 ring-blue-500'
            )}
          >
            <span className="text-slate-500 dark:text-zinc-500 font-medium">{stat.label}</span>
            <span className={cn(
              'font-bold tabular-nums',
              stat.color === 'success' ? 'text-green-600' :
              stat.color === 'warning' ? 'text-amber-600' :
              stat.color === 'danger' ? 'text-red-600' :
              'text-slate-700 dark:text-zinc-200'
            )}>
              {stat.value}
            </span>
          </button>
          {index < stats.length - 1 && (
            <span className="text-slate-500 dark:text-zinc-500 mx-0.5 flex-shrink-0 text-[10px] hidden sm:inline">|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
});

InboxStatsBar.displayName = 'InboxStatsBar';

export default InboxStatsBar;
